import gql from 'graphql-tag'

export const fragRedirection = gql`
  fragment FragRedirection on Redirect {
    action_code
    action_type
    action_data
    enabled
    id
    match_type
    match_url
    url
  }
`
